import {clsx} from 'clsx'

import Styles from './HeroMobileCrop.module.css'

// TODO: Delete once mobile asset OR moving to HTML-rendered UI
export const getHeroMobileCropClassName = (currentChapterIndex: number) => {
  return clsx(Styles.HeroMobileCrop, currentChapterIndex > 0 && Styles.rightAligned)
}
